
import { USPS_BY_PRISMIC_ID } from '@marketplace/graphql/prismic.js'
import { config as prismicConfig } from '@marketplace/helpers/prismic.js'
import { mapGetters } from 'vuex'

export default {
    name: 'PlatformUsps',

    props: {
        prismicDataId: {
            type: String,
            default: '',
        },
        indent: {
            type: Boolean,
            default: false,
        },
        uspList: {
            type: Array,
            default: () => [],
        },
    },

    apollo: {
        usps: {
            skip() {
                return !this.prismicDataId
            },
            query: USPS_BY_PRISMIC_ID,
            client: 'apolloPrismicClient',
            update(data) {
                return data?.usps?.edges?.[0]?.node?.usps
            },
            variables() {
                return {
                    id: this.prismicDataId,
                    lang: prismicConfig.currentLanguage,
                }
            },
        },
    },

    computed: {
        ...mapGetters('global', ['specialTerms']),

        displayedUsps() {
            const usps = this.usps || this.uspList

            if (this.specialTerms) {
                return usps.map((usp, index) => {
                    return {
                        heading: usp.heading.replace(/60/, 30),
                        content: usp.content.replace(/60/, 30),
                    }
                })
            }

            return usps
        },
    },
}
